export const cFinalizadosConstants = {
  CANCELAMENTO_FINALIZADOS_REQUEST: 'CANCELAMENTO_FINALIZADOS_REQUEST',
  CANCELAMENTO_FINALIZADOS_SUCCESS: 'CANCELAMENTO_FINALIZADOS_SUCCESS',
  CANCELAMENTO_FINALIZADOS_FAILURE: 'CANCELAMENTO_FINALIZADOS_FAILURE',
};
